import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

const foregroundColor = '#000000';

const TechStatBanner = (props) => {
    const [ orgCount, setOrgCount ] = useState(0);
    const [ techCount, setTechCount ] = useState(0);
    const [ locationCount, setLocationCount ] = useState(0);

    useEffect(() => {
        if (props.techProviders) {
            setOrgCount(props.techProviders.length);
            const techSet = new Set();
            const locationSet = new Set();
            props.techProviders.forEach(p => {
                if (p.technology_types) {
                    p.technology_types.forEach(t => techSet.add(t));
                }
                if (p.location) {
                    locationSet.add(p.location);
                }
            });
            setTechCount(techSet.size);
            setLocationCount(locationSet.size);
        }

    }, [props.techProviders]);

return(
<Box sx={{ flexGrow: 1 }}>
    <Grid container wrap="nowrap" spacing={2} size={12}>
        <Grid size="grow" textAlign="center" sx={{borderRightWidth: 1, borderRightStyle: 'solid', borderColor: foregroundColor}}>
            <Typography variant="h3" color={foregroundColor}>{orgCount}</Typography>
            <Typography color={foregroundColor}>Organisations</Typography>
        </Grid>
        <Grid size="grow" textAlign="center" sx={{borderRightWidth: 1, borderRightStyle: 'solid', borderColor: foregroundColor}}>
            <Typography variant="h3" color={foregroundColor}>{techCount}</Typography>
            <Typography color={foregroundColor}>Technologies</Typography>
        </Grid>
        <Grid size="grow" textAlign="center">
            <Typography variant="h3" color={foregroundColor}>{locationCount}</Typography>
            <Typography color={foregroundColor}>Locations</Typography>
        </Grid>
    </Grid>
</Box>
);
}

export default TechStatBanner;